export default function extractVideoId(url: string): string {
  // Regular expression to match YouTube video ID
  const regExp: RegExp = /^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/
  const match = url?.match(regExp)

  // Extracted video ID or return the original URL if not found
  return match && match[1] ? match[1] : url
}